import React from 'react'

export default function BakeryReports() {
    return (
        <div>BakeryReports</div>
    )
}
